import FieldSet from '../../FieldSet';
import terminology from 'javascripts/terminology';

import { Product } from './Product';

export class ProductFieldSet extends FieldSet {
  get fieldDefinitions() {
    return [Product];
  }

  get title() {
    return terminology('Product');
  }
}
